export default "<div *ngIf=\"show\" class=\"context-menu-item\" (click)=\"menuItemClick()\">\n  {{ title }}\n</div>\n"